import { Box } from "@mui/material";
import React from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";

export default function MultiLineChart() {
	const state = useSelector((store) => store.analyze);
	const { customerMLCDPrepared, selectedScenarioName, duration, customerChecked } = state;
	const { periods, seriesData } = customerMLCDPrepared;

	const colorMapping = {
		"EFS": "#3366cc",
		"DeliveredQTY": "#ADD8E6", //ADD8E6, F57C00
		"Original Quota": "#F57C00",
		"Final Quota": "#8B8000",
		Month: "#800080",
	  };

	  const series = seriesData?.filter((item) => {
		return customerChecked.includes(item.name);
	})

	const options = {
		title: {
			text: `Analyze: ${selectedScenarioName} Last ${duration} Months`,
			align: "left",
		},
		tooltip: {
			y: {
			  formatter: (value) => {
				const formatter = new Intl.NumberFormat("en-US");
				return formatter.format(value);
			  },
			},
		},
		xaxis: {
			categories: [...periods],
		},
		yaxis: {
			labels: {
			  formatter: (value) => {
				const formatter = new Intl.NumberFormat("en-US");
				return formatter.format(value);
			  },
			},
		},
		stroke: {
			width: 2,
		},
		markers: {
			size: 5,
		},
		colors: series.map(series=>colorMapping[series.name]),
	};
	//const series = [...seriesData];


	console.log(seriesData);
	console.log(customerChecked)

	return (
		// added class name to get this element.
		<Box sx={{ mt: 2 }} className={"multiLineChart"}>
			<Chart
				options={options}
				series={series}
				type="line"
				height={500}
				width={"99%"}
			/>
		</Box>
	);
}
